import { useCallback, useEffect, useState } from "react";
import loader from "../../../../../components/recharts/loader.gif";
import OptimalVolumeAnalysis from "./SystemChart/OptimalVolumeChart";
import OptimalCostAnalysis from "./SystemChart/OptimalCostChart";
import OptimalCumulatedVolumeAnalysis from "./CumulatedChart/OptimalCumulatedVolume";
import OptimalCumulatedCostAnalysis from "./CumulatedChart/OptimalCumulatedCost";

interface DeficitSlot {
  slot: string;
  timeRange: string;
  deficitMW: number;
}

interface SurplusSlot {
  slot: string;
  timeRange: string;
  surplusMW: number;
}

export default function SurplusDeficitAnalysis({
  selectedBlock,
  refreshKey,
  setError,
  setUniqueTargetDate,
  selectedTargetDate,
  activeTab,
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  setUniqueTargetDate?: any;
  selectedTargetDate: any[];
  activeTab: string;
}) {
  const [loading, setLoading] = useState(false);

  return (
    <div className="w-full h-full flex gap-2 min-w-0">
      {/* System Balance Chart - 70% width */}
      <div
        className="h-full min-w-0 !shadow-[rgba(149,157,165,0.2)_0px_8px_24px]"
        style={{ width: "69%", flex: "0 0 69%" }}
      >
        {loading ? (
          <div className="w-full h-full bg-white flex items-center justify-center rounded-2xl border border-[#E5E7EB]">
            <img src={loader} width={200} alt="loader" className="block" />
          </div>
        ) : (
          <div className="w-full h-full min-w-0 overflow-hidden">
            {activeTab === "Volume" && (
              <OptimalVolumeAnalysis
                selectedBlock={selectedBlock}
                refreshKey={refreshKey}
                setError={setError}
                setUniqueTargetDate={setUniqueTargetDate}
                selectedTargetDate={selectedTargetDate}
              />
            )}
            {activeTab === "Cost" && (
              <OptimalCostAnalysis
                selectedBlock={selectedBlock}
                refreshKey={refreshKey}
                setError={setError}
                setUniqueTargetDate={setUniqueTargetDate}
                selectedTargetDate={selectedTargetDate}
              />
            )}
          </div>
        )}
      </div>

      {/* Cumulated Balance Chart - 30% width */}
      <div
        className="h-full min-w-0 overflow-hidden !shadow-[rgba(149,157,165,0.2)_0px_8px_24px]"
        style={{ width: "30%", flex: "0 0 30%" }}
      >
        {loading ? (
          <div className="w-full h-full bg-white flex items-center justify-center rounded-2xl border border-[#E5E7EB]">
            <img src={loader} width={200} alt="loader" className="block" />
          </div>
        ) : (
          <div className="w-full h-full min-w-0 overflow-hidden">
            {activeTab === "Volume" && (
              <OptimalCumulatedVolumeAnalysis
                selectedBlock={selectedBlock}
                refreshKey={refreshKey}
                setError={setError}
                setUniqueTargetDate={setUniqueTargetDate}
                selectedTargetDate={selectedTargetDate}
              />
            )}
            {activeTab === "Cost" && (
              <OptimalCumulatedCostAnalysis
                selectedBlock={selectedBlock}
                refreshKey={refreshKey}
                setError={setError}
                setUniqueTargetDate={setUniqueTargetDate}
                selectedTargetDate={selectedTargetDate}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
